import { Component, OnInit } from '@angular/core';

import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {Pipe} from '@angular/core';
import {IOption} from 'ng-select';
declare  const $;
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import * as moment from 'moment/moment';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AlertComponent } from './../alert/alert.component';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-invoice-report',
  templateUrl: './invoice-report.component.html',
  styleUrls: ['./invoice-report.component.scss']
})
export class InvoiceReportComponent implements OnInit {
	orgId:number;
	userId:number;
	AllServiceList:any[]=[];
	CompletedServiceList=[];
	NotCompletedList=[];
	loading:boolean=false
	OptionsForServices:Array<IOption>=[];
  OptionsForFilter:Array<IOption>=[];
	listShowTable=[];
	fromDate:any;
	toDate:any;
	ServiceRemainderPlaceholder:string='AllService';
  listInvoiceData=[];
  ListAllContractDetails=[];
  ListOfCustomermaster=[];
  AllModalDetails=[];
  SelectOption:any;
  filterOption='Based On Service CarriedOut Date';
  startingCount:number = 0;
  endingCount:number = 0;
  p: number = 1;
  ListAllServcieType=[];
  ListPreviousQuarterCompletedService=[];
  customerNameDropDown:Array<IOption>=[];
  SerialNumberDropDown:Array<IOption>=[];
  CUSTOMERNAMEplaceholder:string="CUSTOMER NAME";
  SERIALNUMBERplaceholder:string="SERIAL NUMBER";
  customerName:any;
  serialnumber:any;
  ListOfCustomerMaster=[];
  customerDetails=[];
  msgtext:any;
  ListOfSerialNumber=[];
  exportDummyList=[];
  	constructor(private dialogService:DialogService,private http: Http,private toastyService:ToastyService,private toastyConfig: ToastyConfig,private router:Router,private route : ActivatedRoute) { }

    private upperOrEmpty(value:any) {
      return (value || '').toString().toUpperCase();
    }

   	ngOnInit() {
  		if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
	      window.location.href = 'https://still.alshirawi.com/highmessaging/';
	    } else {
	      this.orgId=this.route.params['value'].orgId;
	      this.userId=this.route.params['value'].userId;
	      console.log('OrgId '+ this.orgId);
	      console.log('UserId '+ this.userId);
	     
	    }

      var date = new Date(), y = date.getFullYear(), m = date.getMonth();
      let firstDay = new Date(y, m, 1);
      let lastDay = new Date(y, m + 1, 0);
      let firstDate = moment(firstDay).format('YYYY-MM-DD');
      let lastDate = moment(lastDay).format('YYYY-MM-DD');
      this.fromDate = moment(firstDay).format('YYYY-MM-DD');
      this.toDate = moment(lastDay).format('YYYY-MM-DD');
	    
	    let pusharr=[];
	    // pusharr.push({'value':'AllService','label':"All Services"},{'value':'CompletedService','label':'Completed Service'},{'value':'NotCompletedService','label':'Not Completed Service'},{'label':'Previous Quarter Completed Service','value':'PreviousQuarterCompletedService'},{'label':'Completed Service In Before Month','value':'CompletedServiceInBeforeMonth'},{'label':'Completed Service Of Next Month','value':'CompletedServiceOfNextMonth'},{'label':'This Month Service Completed In Next Month','value':'ThisMonthServiceCompletedInNextMonth'});
      pusharr.push({'value':'CompletedService','label':'Completed Service'},{'value':'NotCompletedService','label':'Not Completed Service'});
      this.SelectOption='CompletedService';
	    this.OptionsForServices=pusharr;
      let filterArr=[];
      filterArr.push({'value':'Based On Service CarriedOut Date','label':'Based On Service CarriedOut Date'},{'value':'Based On Service Updation Date','label':'Based On Service Updation Date'})
      this.OptionsForFilter=filterArr;
	    this.getAllServiceTypeDetails();
	    this.loading=true;
	    console.log("fromDate",this.fromDate);
	    console.log("toDate",this.toDate);
  	}

    getCount(){
     if(this.p < Math.ceil(this.listInvoiceData.length/10)){
       this.startingCount = (this.p-1)*10;
       if(this.startingCount == 0){
         this.startingCount = 1;
       }
       this.endingCount = this.p*10;
     } else if(this.p == Math.ceil(this.listInvoiceData.length/10)){
       let count = this.listInvoiceData.length%10;
       this.startingCount = (this.p-1)*10;
       this.endingCount = this.startingCount + count;
       if(this.startingCount == 0){
         this.startingCount = 1;
         this.endingCount = count;
       }
     }
  }

  todate(todate) {
    if(todate < this.fromDate) {
      alert('ToDate should be greater than Form Date');
      this.toDate="";
    }
  }

  Fromdate() {
    this.toDate="";
  }

  customerSelect(value) {
    let customerId;
    for(let c=0;c<this.ListOfCustomermaster.length;c++) {
      if(this.ListOfCustomermaster[c].customer_Name == value) {
        customerId=this.ListOfCustomermaster[c]._id;
      }
    }

    let pusharr=[];
    this.SerialNumberDropDown=[];
    this.ListOfSerialNumber.filter(contract=> {
      if(contract.status == 0) {
        this.AllServiceList.filter(service=> {
          if(this.SelectOption=='CompletedService') {
            if(service.serialNumber == contract.serial_Number && service.status == 1 && service.pmahistorystatus==0 && contract.client_Name == customerId) {
              pusharr.push({'value':contract.serial_Number,'label':this.upperOrEmpty(contract.serial_Number)})
            }
          } else if(this.SelectOption=='NotCompletedService') {
            if(service.serialNumber == contract.serial_Number && service.status == 0 && service.pmahistorystatus==0 && contract.client_Name == customerId) {
              pusharr.push({'value':contract.serial_Number,'label':this.upperOrEmpty(contract.serial_Number)})
            }
          }
          
        });
      }
    })
    this.SerialNumberDropDown=pusharr;

  }

    getAllserialNumberDetails() {
        this.loading=true;
        let PMSObj = {
          'orgId':this.orgId
        }
        return this.http.post('/api/getAllPreventiveMaintenanceDetailsForInvoice', PMSObj).subscribe(
            res => {
                 
            this.ListAllContractDetails = res.json();
            this.ListOfSerialNumber = res.json();
            let pusharr=[];
            this.SerialNumberDropDown=[];
           
            
            for(let i=0;i<this.ListOfSerialNumber.length;i++){
              if(this.ListOfSerialNumber[i].status == 0 ) {
                pusharr.push({'value':this.ListOfSerialNumber[i].serial_Number,'label':this.upperOrEmpty(this.ListOfSerialNumber[i].serial_Number)})
              }
               
              

            }

           
            this.SerialNumberDropDown=pusharr;
            this.completedService(this.SelectOption);
        },(err)=>{
          this.loading=false;
          console.log(err);
        })
    }


    getAllServiceTypeDetails() {
      let reqServiceTypeObj = { 
        'orgId':this.orgId
      }
      return this.http.post('/api/getServiceTypedetails', reqServiceTypeObj).subscribe(
        res => {
           this.ListAllServcieType = res.json();
           console.log(this.ListAllServcieType);
           this.getmodeldetails()
        },(err)=>{
          this.loading=false;
          this.getmodeldetails()
           console.log(err);
        })
    }

    getmodeldetails() {
      let modelObj = {
         'orgId':this.orgId
      }
      return this.http.post('/api/getModelDetails', modelObj).subscribe(
        res => {
          this.AllModalDetails = [];
          let response = res.json();
          if(response.length>0) {
            this.AllModalDetails =response;
          }
          this.getAllCustomerMasterDetails()
        },(err)=>{
          this.loading=false;
          console.log(err);
          this.getAllCustomerMasterDetails();
      })
    }

    getAllCustomerMasterDetails() {
      let CustomerObj = {
        'orgId':this.orgId
      }
      return this.http.post('/api/getCustomerMasterDetails', CustomerObj).subscribe(
        res => {
          this.ListOfCustomermaster = res.json();
          this.ListOfCustomerMaster = res.json();
          this.customerNameDropDown=[];
           for(var i=0;i<this.ListOfCustomerMaster.length;i++) {
             let obj = {
               'Id':this.ListOfCustomerMaster[i]._id,
               'Name':this.ListOfCustomerMaster[i].customer_Name
             }
            this.customerDetails.push(obj); 
          }
          let pusharr=[];
          for(let i=0;i<this.ListOfCustomerMaster.length;i++){
            pusharr.push({'value':this.ListOfCustomerMaster[i].customer_Name,'label':this.upperOrEmpty(this.ListOfCustomerMaster[i].customer_Name)})
          }
          this.customerNameDropDown=pusharr;
          this.getAllserialNumberDetails()
        },(err) =>{
          console.log(err);
          this.loading=false;
          this.getAllserialNumberDetails();
        })
    }

  	getReports(value){
      let obj={
        'orgId':this.orgId,
        'fromDate':this.fromDate,
        'toDate':this.toDate
      }
      return this.http.post("/api/getAllServiceStatusDetails",obj).subscribe(res=>{
        console.log(res.json())
        this.listInvoiceData=[];
        this.exportDummyList = [];
        this.AllServiceList=res.json();
        let clientName;
        let Model;
        let serviceNumber;
        let serialNumber;
        let pmahistory;
        let contractlevel;
        let serviceType;
        let HMR;
        let trueCondition=0;
        let updateDate;
        let mcLocation;
        if(this.AllServiceList.length>0) {
          for(let i=0;i<this.AllServiceList.length;i++){
            trueCondition=0;
            clientName='';
            Model='';
            serviceNumber='';
            serialNumber='';
            pmahistory='';
            contractlevel='';
            serviceType='';
            HMR='';
            updateDate='';
            mcLocation='';
            for(let j=0;j<this.ListAllContractDetails.length;j++) {
              if((this.ListAllContractDetails[j].no_Of_Service >= this.AllServiceList[i].service_Scheduler_Number ) && (this.AllServiceList[i].serialNumber==this.ListAllContractDetails[j].serial_Number) && (this.AllServiceList[i].contractLevel == this.ListAllContractDetails[j].contractLevel) && (this.AllServiceList[i].status == 1 || this.AllServiceList[i].status == 0)) {
                // if((this.AllServiceList[i].pmahistorystatus == 1) && (this.AllServiceList[i].status==0)) {

                // } else {
                  trueCondition=1;
                  for(let c=0;c<this.ListOfCustomermaster.length;c++) {

                    if(this.ListOfCustomermaster[c]._id == this.ListAllContractDetails[j].client_Name) {
                      clientName=this.ListOfCustomermaster[c].customer_Name;
                    }
                  }
                  
                  for(let m=0;m<this.AllModalDetails.length;m++) {
                    if(this.AllModalDetails[m]._id == this.ListAllContractDetails[j].model) {
                      Model=this.upperOrEmpty(this.AllModalDetails[m].model)
                    }
                  }

                  for(let ls=0;ls<this.ListAllServcieType.length;ls++) {
                    if(this.ListAllServcieType[ls]._id == parseInt(this.AllServiceList[i].service_Type)) {
                        serviceType = this.ListAllServcieType[ls].servicetype;
                     }
                  }
                  
                  if(this.ListAllContractDetails[j].serviceScheduleDay >1) {
                    serviceNumber=this.AllServiceList[i].service_Scheduler_Number;
                  } else {
                    serviceNumber=this.AllServiceList[i].service_Scheduler_Number;
                  }
                  serialNumber=this.ListAllContractDetails[j].serial_Number;
                  HMR=this.ListAllContractDetails[j].Servicedetails[this.AllServiceList[i].service_Scheduler_Number-1].hmr;
                  if(this.AllServiceList[i].updated_Date == null) {
                    updateDate="Not Updated";
                  } else {
                    updateDate=moment(this.AllServiceList[i].updated_Date.split(" ")[0].replace(/[:]/g,'-')).format('D MMM YYYY');  
                  }
                // }
                mcLocation=this.ListAllContractDetails[j].mcLocation;
                pmahistory=this.AllServiceList[i].pmahistorystatus;
                
              }
            }
            if(trueCondition == 1) {
                 
              let obj = {
                'clientName':this.upperOrEmpty(clientName),
                'serialNumber':serialNumber,
                'model':Model,
                'serviceNumber':serviceNumber,
                'serviceType':this.upperOrEmpty(serviceType),
                'serviceCarriedOutDate':moment(this.AllServiceList[i].service_CarriedOut_Date).format('D MMM YYYY'),
                'hmr':HMR,
                'mcLocation':mcLocation,
                'updateDate':updateDate,
                'status':this.AllServiceList[i].status,
                'pmahistory':this.AllServiceList[i].pmahistorystatus,
                
              }
              console.log('_______object '+ JSON.stringify(obj))
              if(this.customerName == clientName && (this.serialnumber == '' || this.serialnumber == undefined)) {
                this.listInvoiceData.push(obj);
              } else if(this.serialnumber == serialNumber && (this.customerName == '' || this.customerName == undefined)) {
                this.listInvoiceData.push(obj);
              } else if(this.serialnumber == serialNumber && this.customerName == clientName) {
                this.listInvoiceData.push(obj);
              } else if((this.serialnumber == null || this.serialnumber == '') && (this.customerName == null || this.customerName == '')) {
                this.listInvoiceData.push(obj);
              }
              
            } else {

            }

            if(value == 'CompletedServiceInBeforeMonth') {
              this.ListPreviousQuarterCompletedService = this.listInvoiceData;
              this.listInvoiceData=[];
              for(let i=0;i<this.ListPreviousQuarterCompletedService.length;i++) {
                if((moment(this.ListPreviousQuarterCompletedService[i].updateDate).format('YYYY-MM-DD') < this.fromDate) && (this.ListPreviousQuarterCompletedService[i].status == 1)) {
                  this.listInvoiceData.push(this.ListPreviousQuarterCompletedService[i]);
                }
              }
            } else if(value == 'ThisMonthServiceCompletedInNextMonth') {
              this.ListPreviousQuarterCompletedService = this.listInvoiceData;
              this.listInvoiceData=[];
              for(let i=0;i<this.ListPreviousQuarterCompletedService.length;i++) {
                if((moment(this.ListPreviousQuarterCompletedService[i].updateDate).format('YYYY-MM-DD') > this.toDate) && (this.ListPreviousQuarterCompletedService[i].status == 1)) {
                  this.listInvoiceData.push(this.ListPreviousQuarterCompletedService[i]);
                }
              }
            }

          }
        }
        console.log(this.listInvoiceData);
        this.exportDummyList = this.listInvoiceData;
        this.loading=false;
      },(err)=>{
        this.loading=false;
      })
    }

    search() {
      if(this.fromDate == "" || this.fromDate == null || this.fromDate == undefined ) {
        alert('please select the From Date');
      } else if(this.toDate == "" || this.toDate == null || this.toDate == undefined ) {
        alert('please select the To Date');
      } else {
        // this.ServiceRemainderPlaceholder='CompletedService'
        // this.SelectOption="CompletedService";
        this.ShowData(this.SelectOption);
      }
     
    }

    applyFilter(searchData) {
      this.exportDummyList = this.filterFromJSON(this.listInvoiceData, searchData);
      console.log(this.exportDummyList);
    }

    filterFromJSON(jsonList, searchData) {
      return jsonList.filter(e => e.clientName.includes(searchData) || e.serialNumber.includes(searchData))
       .sort((a,b) => a.clientName.includes(searchData) && !b.clientName.includes(searchData) ? -1 : b.clientName.includes(searchData) && !a.clientName.includes(searchData) ? 1 :0);
    }


    exportdata(event) {
      if(this.exportDummyList.length > 0) {
        let  data=[];
        let Reportstartdate = moment(this.fromDate).format('D MMM YYYY');
        let Reportenddate = moment(this.toDate).format('D MMM YYYY');
        let title=Reportstartdate+' '+'to'+' '+ Reportenddate+' '+'Service Completion Report.xlsx'
        data.push([Reportstartdate+' '+'to'+' '+ Reportenddate+' '+'SERVICE COMPLETION REPORT'])
        data.push([])
        data.push(['S NO','CUSTOMER NAME','SERIAL NUMBER','MODEL','SERVICE NUMBER',"SERVICE TYPE","SERVICE CARRIEDOUT DATE","SERVICE UPDATED DATE","HMR","STATUS"]);
        let statusValue;
        for(let i=0;i<this.exportDummyList.length;i++) {
          // if(this.exportDummyList[i].status==0) {
          //   statusValue='Not Completed'
          // } else {
          //   statusValue='Completed'
          // }
          if (this.exportDummyList[i].status == 0) {
            statusValue = 'Not Completed'
          } else {
            if (this.exportDummyList[i].pmahistory !== 0) {
              statusValue = 'Completed and Deleted';
            } else {
              statusValue = 'Completed';
            }
          }
          data.push([i+1,this.exportDummyList[i].clientName,this.exportDummyList[i].serialNumber,this.exportDummyList[i].model,this.exportDummyList[i].serviceNumber,this.exportDummyList[i].serviceType,this.exportDummyList[i].serviceCarriedOutDate,this.exportDummyList[i].updateDate,this.exportDummyList[i].hmr,statusValue])
        }
        let wb: XLSX.WorkBook =XLSX.utils.book_new();
        const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);

        XLSX.utils.book_append_sheet(wb, ws,'Service Completion Report');
        XLSX.writeFile(wb,title); 
      }else {
        alert('No Records Found');
      }
      
   
    }

    reset() {
      this.customerName = "";
      this.serialnumber = "";
      this.CUSTOMERNAMEplaceholder="CUSTOMER NAME";
      this.SERIALNUMBERplaceholder="SERIAL NUMBER";
      this.SelectOption = 'CompletedService';
      this.getAllserialNumberDetails();
      // this.ShowData(this.SelectOption);
    }

    completedService(value) {
      let addday=1;
      let obj = {};
      if(this.filterOption == 'Based On Service CarriedOut Date') {
        obj={
          'orgId':this.orgId,
          'fromDate':this.fromDate,
          'toDate':this.toDate,
          'filterOption':this.filterOption
        }
      } else if(this.filterOption == 'Based On Service Updation Date') {
        obj={
          'orgId':this.orgId,
          'fromDate':moment(this.fromDate).format('YYYY:MM:DD'),
          'toDate':moment(this.toDate).add(addday, 'days').format('YYYY:MM:DD'),
          'filterOption':this.filterOption
        }
      }
      
        return this.http.post("/api/getServiceDetailsCompletedListForInvoice",obj).subscribe(res=>{
          this.listInvoiceData=[];
          this.exportDummyList=[];
          this.AllServiceList=res.json();
   
          let clientName;
          let Model;
          let serviceNumber;
          let serialNumber;
          let pmahistory;
          let contractlevel;
          let serviceType;
          let HMR;
          let updateDate;
          let trueCondition=0;
          let mcLocation;
          if(this.AllServiceList.length>0) {
            for(let i=0;i<this.AllServiceList.length;i++){
              trueCondition=0;
              clientName='';
              Model='';
              serviceNumber='';
              serialNumber='';
              pmahistory='';
              contractlevel='';
              serviceType='';
              HMR='';
              updateDate='';
              mcLocation='';
              for(let j=0;j<this.ListAllContractDetails.length;j++) {
                if((this.ListAllContractDetails[j].no_Of_Service >= this.AllServiceList[i].service_Scheduler_Number ) && (this.AllServiceList[i].serialNumber==this.ListAllContractDetails[j].serial_Number) && (this.AllServiceList[i].contractLevel == this.ListAllContractDetails[j].contractLevel) && (this.AllServiceList[i].status == 1)) {

                  trueCondition=1;
                  for(let c=0;c<this.ListOfCustomermaster.length;c++) {
                    if(this.ListOfCustomermaster[c]._id == this.ListAllContractDetails[j].client_Name) {
                      clientName=this.ListOfCustomermaster[c].customer_Name;
                    }
                  }
                  
                  for(let m=0;m<this.AllModalDetails.length;m++) {
                    if(this.AllModalDetails[m]._id == this.ListAllContractDetails[j].model) {
                      Model=this.upperOrEmpty(this.AllModalDetails[m].model)
                    }
                  }

                  for(let ls=0;ls<this.ListAllServcieType.length;ls++) {
                    if(this.ListAllServcieType[ls]._id == parseInt(this.AllServiceList[i].service_Type)) {
                        serviceType = this.ListAllServcieType[ls].servicetype;
                     }
                  }
                  
                  if(this.ListAllContractDetails[j].serviceScheduleDay >1) {
                    serviceNumber=this.AllServiceList[i].service_Scheduler_Number;
                  } else {
                    serviceNumber=this.AllServiceList[i].service_Scheduler_Number;
                  }
                  serialNumber=this.ListAllContractDetails[j].serial_Number;
                  console.log("HMR i ", i);
                  console.log("HMR j ", j);
                  console.log("HMR checking ", this.ListAllContractDetails[j].Servicedetails[this.AllServiceList[i].service_Scheduler_Number-1].hmr)
                  
                  HMR=this.ListAllContractDetails[j].Servicedetails[this.AllServiceList[i].service_Scheduler_Number-1].hmr;
                  if(this.AllServiceList[i].updated_Date == null) {
                    updateDate="Not Updated";
                  } else {
                    updateDate=moment(this.AllServiceList[i].updated_Date.split(" ")[0].replace(/[:]/g,'-')).format('D MMM YYYY');  
                  }
                  mcLocation=this.ListAllContractDetails[j].mcLocation;
                  pmahistory=this.AllServiceList[i].pmahistorystatus;
                }
              }
              if(trueCondition == 1) {
                   
                let obj = {
                  'clientName':this.upperOrEmpty(clientName),
                  'serialNumber':serialNumber,
                  'model':Model,
                  'serviceNumber':serviceNumber,
                  'serviceType':this.upperOrEmpty(serviceType),
                  'serviceCarriedOutDate':moment(this.AllServiceList[i].service_CarriedOut_Date).format('D MMM YYYY'),
                  'hmr':HMR,
                  'mcLocation':mcLocation,
                  'updateDate':updateDate,
                  'status':this.AllServiceList[i].status,
                  "pmahistory":this.AllServiceList[i].pmahistorystatus,
                }
                 if(this.customerName == clientName && (this.serialnumber == '' || this.serialnumber == undefined)) {
                    this.listInvoiceData.push(obj);
                  } else if(this.serialnumber == serialNumber && (this.customerName == '' || this.customerName == undefined)) {
                    this.listInvoiceData.push(obj);
                  } else if(this.serialnumber == serialNumber && this.customerName == clientName) {
                    this.listInvoiceData.push(obj);
                  } else if((this.serialnumber == null || this.serialnumber == '') && (this.customerName == null || this.customerName == '')) {
                    this.listInvoiceData.push(obj);
                  }
              } else {

              }
            } //end for loop
            if(value == 'PreviousQuarterCompletedService') {
              this.ListPreviousQuarterCompletedService = this.listInvoiceData;
              this.listInvoiceData=[];
              for(let i=0;i<this.ListPreviousQuarterCompletedService.length;i++) {
                if(moment(this.ListPreviousQuarterCompletedService[i].serviceCarriedOutDate).format('YYYY-MM-DD') < this.fromDate) {
                  this.listInvoiceData.push(this.ListPreviousQuarterCompletedService[i]);
                }
              }
            } else if(value == 'CompletedServiceOfNextMonth') {
              this.ListPreviousQuarterCompletedService = this.listInvoiceData;
              this.listInvoiceData=[];
              for(let i=0;i<this.ListPreviousQuarterCompletedService.length;i++) {
                if((moment(this.ListPreviousQuarterCompletedService[i].serviceCarriedOutDate).format('YYYY-MM-DD') > this.toDate) && (this.ListPreviousQuarterCompletedService[i].status == 1)) {
                  this.listInvoiceData.push(this.ListPreviousQuarterCompletedService[i]);
                }
              }
            } 
            console.log(this.listInvoiceData);
            this.exportDummyList = this.listInvoiceData;
          }

          this.loading=false;
        },(err)=>{
          this.loading=false;
        })
    }


    selectOptionDC(value) {
      this.customerName = "";
      this.serialnumber = "";
      this.CUSTOMERNAMEplaceholder="CUSTOMER NAME";
      this.SERIALNUMBERplaceholder="SERIAL NUMBER";
      this.SerialNumberDropDown=[];
      let pusharr=[];
      for(let i=0;i<this.ListOfSerialNumber.length;i++){
        if(this.ListOfSerialNumber[i].status == 0 ) {
          pusharr.push({'value':this.ListOfSerialNumber[i].serial_Number,'label':this.upperOrEmpty(this.ListOfSerialNumber[i].serial_Number)})
        }
      }
      this.SerialNumberDropDown=pusharr;
      this.ShowData(value)
    }

    ShowData(value) {
         
      this.loading=true;
      
      if(value == 'CompletedService' || value == 'PreviousQuarterCompletedService' || value == 'CompletedServiceOfNextMonth') {
        this.completedService(value);
      } else if(value == 'CompletedServiceInBeforeMonth' || value == 'ThisMonthServiceCompletedInNextMonth'){
        this.getReports(value);
      } else if(value == 'NotCompletedService') {
        let obj={
          'orgId':this.orgId,
          'fromDate':this.fromDate,
          'toDate':this.toDate
        }
        return this.http.post("/api/getAllServiceStatusDetails",obj).subscribe(res=>{
          console.log(res.json())
          this.listInvoiceData=[];
          this.exportDummyList = [];
          this.AllServiceList=res.json();
          let clientName;
          let Model;
          let serviceNumber;
          let serialNumber;
          let pmahistory;
          let contractlevel;
          let serviceType;
          let HMR;
          let updateDate;
          let trueCondition=0;
          let mcLocation;
          if(this.AllServiceList.length>0) {
            for(let i=0;i<this.AllServiceList.length;i++){
              trueCondition=0;
              clientName='';
              Model='';
              serviceNumber='';
              serialNumber='';
              pmahistory='';
              contractlevel='';
              serviceType='';
              HMR='';
              updateDate='';
              mcLocation='';
              for(let j=0;j<this.ListAllContractDetails.length;j++) {
                if((this.ListAllContractDetails[j].no_Of_Service >= this.AllServiceList[i].service_Scheduler_Number ) && (this.AllServiceList[i].serialNumber==this.ListAllContractDetails[j].serial_Number) && (this.AllServiceList[i].contractLevel == this.ListAllContractDetails[j].contractLevel) && (this.AllServiceList[i].status == 0) && (this.AllServiceList[i].pmahistorystatus == 0)) {
                 
                  trueCondition=1;
                  for(let c=0;c<this.ListOfCustomermaster.length;c++) {
                    if(this.ListOfCustomermaster[c]._id == this.ListAllContractDetails[j].client_Name) {
                      clientName=this.ListOfCustomermaster[c].customer_Name;
                    }
                  }
                  
                  for(let m=0;m<this.AllModalDetails.length;m++) {
                    if(this.AllModalDetails[m]._id == this.ListAllContractDetails[j].model) {
                      Model=this.upperOrEmpty(this.AllModalDetails[m].model)
                    }
                  }

                  for(let ls=0;ls<this.ListAllServcieType.length;ls++) {
                    if(this.ListAllServcieType[ls]._id == parseInt(this.AllServiceList[i].service_Type)) {
                        serviceType = this.ListAllServcieType[ls].servicetype;
                     }
                  }
                  
                  if(this.ListAllContractDetails[j].serviceScheduleDay >1) {
                    serviceNumber=this.AllServiceList[i].service_Scheduler_Number;
                  } else {
                    serviceNumber=this.AllServiceList[i].service_Scheduler_Number;
                  }
                  serialNumber=this.ListAllContractDetails[j].serial_Number;
               

                  HMR=this.ListAllContractDetails[j].Servicedetails[this.AllServiceList[i].service_Scheduler_Number-1].hmr;
                  if(this.AllServiceList[i].updated_Date == null) {
                    updateDate="Not Updated";
                  } else {
                    updateDate=moment(this.AllServiceList[i].updated_Date.split(" ")[0].replace(/[:]/g,'-')).format('D MMM YYYY');  
                  }
                  mcLocation=this.ListAllContractDetails[j].mcLocation;
                  pmahistory=this.AllServiceList[i].pmahistorystatus;
                }
              }
              if(trueCondition == 1) {
                   
                let obj = {
                  'clientName':this.upperOrEmpty(clientName),
                  'serialNumber':serialNumber,
                  'model':Model,
                  'serviceNumber':serviceNumber,
                  'serviceType':this.upperOrEmpty(serviceType),
                  'serviceCarriedOutDate':moment(this.AllServiceList[i].service_CarriedOut_Date).format('D MMM YYYY'),
                  'hmr':HMR,
                  'mcLocation':mcLocation,
                  'updateDate':updateDate,
                  'status':this.AllServiceList[i].status,
                  'pmahistory':this.AllServiceList[i].pmahistorystatus,
                 
                }
                console.log('_______object '+ JSON.stringify(obj))
                if(this.customerName == clientName && (this.serialnumber == '' || this.serialnumber == undefined)) {
                  this.listInvoiceData.push(obj);
                } else if(this.serialnumber == serialNumber && (this.customerName == '' || this.customerName == undefined)) {
                  this.listInvoiceData.push(obj);
                } else if(this.serialnumber == serialNumber && this.customerName == clientName) {
                  this.listInvoiceData.push(obj);
                } else if((this.serialnumber == null || this.serialnumber == '') && (this.customerName == null || this.customerName == '')) {
                  this.listInvoiceData.push(obj);
                }
               
              } else {

              }
            }
          }
          console.log(this.listInvoiceData);
          this.exportDummyList = this.listInvoiceData;
          this.loading=false;
        },(err)=>{
          this.loading=false;
        })
      } else if(value == 'AllService') {
        this.getReports(value);
      }
      console.log(this.listInvoiceData);
    }
  
  getWarningFunction(errMsg) {
      var toastOptions:ToastOptions = {
          title: "History page",
          msg: errMsg,
          showClose: true,
          timeout: 3000,
          theme: 'bootstrap',
          onAdd: (toast:ToastData) => {
          },
          onRemove: function(toast:ToastData) {
          }
        };
      this.toastyService.warning(toastOptions);
  }//getWarningFunction end here

}



// WEBPACK FOOTER //
// ./client/app/invoice-report/invoice-report.component.ts